<p>project-equipment-grid works!</p>
